/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getContextInstancesOverrides';

export type GetContextInstancesPathParams = NonNullable<operations['getContextInstances']['parameters']['path']>;

export type GetContextInstancesQueryParams = NonNullable<operations['getContextInstances']['parameters']['query']>;

export interface Input extends GetContextInstancesPathParams {
  apiVersion?: string;
  query?: GetContextInstancesQueryParams;
}

export async function getContextInstances(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/environments/{environmentKey}/context-instances/{id}', {
    params: { path, query },
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
